export type ModifiedField = [string, string]
export type Converter<T> = {
  icon: () => string
  title: () => string
  subTitle: (x: T) => Promise<string>
  modifiedFields: (
    modified: T,
    column: keyof T,
    base: Record<string, any> | undefined
  ) => Promise<ModifiedField> | undefined
}

export const asModifiedField = (label: string, value: any): Promise<ModifiedField> =>
  Promise.resolve([label, `${value}`])
